import { ELOOP } from "constants";
import tools from "tools";

export default async function oldVjs(options) {
  const El = document.getElementsByTagName("body")[0];
  const link = document.createElement("script");
  link.type = "text/javascript";
  link.src = "//cdnjs.cloudflare.com/ajax/libs/video.js/6.0.0/video.min.js";
  console.log('1');
  const link2 = document.createElement("script");
  link2.type = "text/javascript";
  link2.src =
    "//cdnjs.cloudflare.com/ajax/libs/videojs-contrib-hls/4.1.1/videojs-contrib-hls.min.js" 
  console.log("1")
  // const link3 = document.createElement("script");
  // link3.type = "text/javascript";
  // link3.src = "//unpkg.com/videojs-flash/dist/videojs-flash.js";
  
  El.appendChild(link);
  await tools.loadFile(
    "https://unpkg.com/videojs-flash/dist/videojs-flash.js",
    // "https://unpkg.com/videojs-contrib-hls/dist/videojs-contrib-hls.js",
    "script",
    "head",
  );
  setTimeout(() => {
    El.appendChild(link2);
    console.log("2")
    // setTimeout (() => {
    // // EL.appendChild(link3);
    // console;log("3")
    setTimeout(() => {
      techOrder = ["flash"];
      const vjs = window.videojs(options.playerID, {
        flash: {
          // hls: {
          // // el,
          nativeTextTracks: false,
          // }
        },
        ...options,
        plugins: {},
      });
      vjs.src({
        src: options.src,
        type: options.type,
      });
    }, 800);
  }, 800);
// }, 800)

  return "done";
}



// WEBPACK FOOTER //
// ./src/js/utils/combo_gagnant.js